<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible" style="text-align: left">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">

      <el-form-item label="角色" prop="roleIdList">
        <el-select v-model="dataForm.roleIdList" multiple clearable filterable placeholder="请选择" style="width: 100%">
          <el-option
            v-for="role in roleList"
            :key="role.roleId"
            :label="role.roleName"
            :value="role.roleId">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        orgNoOptions: this.treeDataTranslate(JSON.parse(sessionStorage.getItem('orgList') || '[]'), 'orgNo', 'parentNo'),
        orgListTreeProps: {
          label: 'orgName',
          children: 'children'
        },
        visible: false,
        roleList: [],
        dataForm: {
          roleIdList: []
        },
        dataRule: {
          userName: [{required: true, message: '用户名不能为空', trigger: 'blur'}],
          sex: [{required: true, message: '性别不能为空', trigger: 'blur'}],
          realName: [{required: true, message: '真实姓名不能为空', trigger: 'blur'}]
        }
      }
    },
    methods: {
      init (id) {
        console.log(id);
        if(!id) return
        this.dataForm.id = id
        this.$http({
          url: '/bjba/sys/role/list',
          method: 'get'
        }).then(({data}) => {
          this.roleList = data && data.code === 200 ? data.data : []
        }).then(() => {
          this.visible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
          })
        }).then(() => {
          if (this.dataForm.id) {
            this.$http({
              url: `/bjba/sys/role/getUserRole/` + this.dataForm.id,
              method: 'get'
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.dataForm.roleIdList = data.data
              }
            })
          } else {
            this.dataForm.orgName = ''
          }
        })
      },
      // 机构树设置当前选中节点
      orgListTreeSetCurrentNode (type) {
        if (type === 'mod') {
          this.$refs.orgListTree.setCurrentKey(this.dataForm.parentNo)
          this.dataForm.parentName = (this.$refs.orgListTree.getCurrentNode() || {})['orgName']
        }
      },
      // 机构树选中
      orgListTreeCurrentChangeHandle (data) {
        this.dataForm.orgNo = data.orgNo
        this.dataForm.orgName = data.orgName
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: `/bjba/sys/role/setUserRole`,
              method: 'post',
              data: {
                'userid': this.dataForm.id || undefined,
                'roleids': this.dataForm.roleIdList
              }
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.visible = false
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.$emit('refreshDataList')
              }
            })
          }
        })
      },
      /**
       * 树形数据转换
       * @param {*} data list数据
       * @param {*} id 主键ID
       * @param {*} pid 上级ID
       * @param childrenKey 子list数据的key
       */
      treeDataTranslate (data, id = 'id', pid = 'parentId', childrenKey = 'children') {
        let res = []
        let temp = {}
        for (let i = 0; i < data.length; i++) {
          temp[data[i][id]] = data[i]
        }
        for (let k = 0; k < data.length; k++) {
          if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
            if (!temp[data[k][pid]][childrenKey]) {
              temp[data[k][pid]][childrenKey] = []
            }
            if (!temp[data[k][pid]]['_level']) {
              temp[data[k][pid]]['_level'] = 1
            }
            data[k]['_level'] = temp[data[k][pid]]._level + 1
            temp[data[k][pid]][childrenKey].push(data[k])
          } else {
            res.push(data[k])
          }
        }
        return res
      }

    }
  }
</script>
<style scoped>
  .mod-org {

    .org-list__input,
    .icon-list__input {

      > .el-input__inner {
        cursor: pointer;
      }

    }
    &
    __icon-popover {
      max-width: 350px;
    }

    &
    __icon-list {
      max-height: 380px;
      padding: 0;
      margin: -8px 0 0 -8px;

      > .el-button {
        padding: 8px;
        margin: 8px 0 0 8px;

        > span {
          display: inline-block;
          vertical-align: middle;
          width: 18px;
          height: 18px;
          font-size: 18px;
        }

      }
    }
    .icon-list__tips {
      font-size: 18px;
      text-align: center;
      color: #e6a23c;
      cursor: pointer;
    }

  }
</style>
